/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

export const AdminConfigType = {
  id: 'admin-config-type.get',
  tag: 'Admin',
  summary: 'Admin Config type',
  description: 'Get all admin config by type',
  method: 'get',
  flags: { isAuthorized: true, isSuperuser: true },
  route: () => `/administration/config/jira`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            id: z.string(),
            type: z.enum(['jira']),
            configData: z.strictObject({
              email: z.string(),
              token: z.string(),
              serviceDeskKey: z.string(),
              serviceDeskId: z.string(),
              atlassianUrl: z.string(),
            }),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
